export const MIN_VISIBLE_ITEMS_COUNT = 3;
export const DATA_TEST_IDS = {
  CONTAINER: 'concepts-container'
};
